import {ContentBox} from '../../../../index';
import React from 'react';
import {useQuery} from '@apollo/react-hooks';
import {RECOMMENDED_PLAYLISTS_QUERY} from './graphql/RecommendedPlaylistsQuery';
import {recommendedPlaylists} from './graphql/types/recommendedPlaylists';
import DiscoverPlaylist from './DiscoverPlaylist';

export default function Discover() {
  const {data, loading} = useQuery<recommendedPlaylists>(
    RECOMMENDED_PLAYLISTS_QUERY,
  );

  const content = data?.me?.library?.recommendations?.map((playlist) => {
    console.log(playlist.id);
    return (
      <DiscoverPlaylist
        image={playlist.artwork.smallUrl}
        name={playlist.name}
        id={playlist.id}
        key={playlist.id}
      />
    );
  });

  return (
    <ContentBox title="Discover">
      {loading ? <p>loading...</p> : content}
    </ContentBox>
  );
}
